import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.apiKey.DOC}
  query ApiKeys($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        apiKeys {
          ...FragmentApiKey
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.ApiKeysQuery,
    readonly ents.core.admin.ApiKey[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'apiKeys',
        graphql.transformers.OUT.list(fragments.apiKey.TRANSFORMER, {
          onNullish: 'remove',
        }),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.ApiKeysQuery,
  readonly ents.core.admin.ApiKey[],
  graphql.schema.ApiKeysQueryVariables
>({ query: DOC, transformer: TRANSFORMER })
